import localEntityListInMenuItem from 'src/components/LeftDrawerMenu/utils/localEntityListInMenuItem';
export default localEntityListInMenuItem;
